const initialState = {
  isLoading: false,
  user: {},
  errors: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_REQ":
      return {
        ...state,
        isLoading: true,
      };
    case "SET_USER":
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };
    case "USER_FAIL":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
